import type { FC } from 'react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { selectIsCouponQuickBetsV2, setCouponQuickBetsV2, setPaymentSourceV2 } from '@mwl/core-lib';
import { Switch } from '@/components/Switch/Switch';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import type { CouponQuickBetSwitchProps } from './CouponQuickBetSwitch.types';
import styles from './CouponQuickBetSwitch.module.scss';
const CouponQuickBetSwitch: FC<CouponQuickBetSwitchProps> = ({
  disabled
}) => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const isQuickBets = useTypedSelector(selectIsCouponQuickBetsV2);
  const handleChangeQuickBets = useCallback(() => {
    dispatch(setCouponQuickBetsV2(!isQuickBets));
  }, [isQuickBets, dispatch]);
  useEffect(() => {
    if (isQuickBets) {
      dispatch(setPaymentSourceV2({
        id: null,
        type: 'BALANCE'
      }));
    }
  }, [isQuickBets, dispatch]);
  return <div className={styles.root} data-sentry-component="CouponQuickBetSwitch" data-sentry-source-file="CouponQuickBetSwitch.tsx">
      <span className={styles.toggleControlLabel}>{t('coupon.enable_quick_bets', 'Enable Quick Betting Mode')}</span>
      <Switch active={isQuickBets} onChange={handleChangeQuickBets} disabled={disabled} data-sentry-element="Switch" data-sentry-source-file="CouponQuickBetSwitch.tsx" />
    </div>;
};
export { CouponQuickBetSwitch };